<template>

    <m-edit1/>

    <m-board-1 v-bind='{...{},...{}}' :style='""' class="" ></m-board-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mBoard1 from '@moeinmdn/miw-alpha-components/src/package/Dashboard/CRM/Board/Board1/Board1';

export default {
    name: 'HomeView',
    components: {mEdit1, mBoard1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
